
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQ from './FAQ';
import GoogleTagManager from '../components/GoogleTagManager';


function Mumbaitopandharpurcab() {



    const cardData =
    {
        keyword: ' Mumbai to Pandharpur Cab    ',
        heading: 'Deva Cabs: Mumbai to Pandharpur Cab   ',
        headingDescription: 'Deva Cabs provides safe and convenient cab services from Mumbai to Pandharpur, perfect for pilgrimage travel, family visits, and spiritual journeys. Covering a distance of approximately 350 km, our cabs offer a smooth ride to the sacred town of Lord Vitthal. Choose from Sedans, SUVs, or Innova Crysta, all driven by experienced chauffeurs for a peaceful and comfortable journey. With fixed fares, 24/7 service, and door-to-door pickup, Deva Cabs ensures a hassle-free trip from Mumbai to Pandharpur.',

        top: 'Top Places to Visit in Pandharpur with Deva Cabs',

"topPlaces": [
  {
    "title": "Vitthal Rukmini Mandir",
    "location": "Pandharpur, Maharashtra",
    "description": "The Vitthal Rukmini Mandir is the heart of Pandharpur and one of the most sacred pilgrimage sites in Maharashtra. Dedicated to Lord Vitthal (a form of Krishna) and Goddess Rukmini, the temple attracts millions of devotees, especially during the Ashadhi and Kartiki Ekadashi yatras. The black stone idol of Vitthal standing on a brick is iconic and deeply revered."
  },
  {
    "title": "Pundalik Mandir",
    "location": "Pandharpur, Maharashtra",
    "description": "Located near the main Vitthal temple, Pundalik Mandir honors the legendary devotee Pundalik, whose devotion is said to have brought Lord Vitthal to Pandharpur. The temple is small but holds great spiritual importance in the Bhakti movement and the Vitthal tradition."
  },
  {
    "title": "Chandrabhaga River (Bhima River)",
    "location": "Pandharpur, Maharashtra",
    "description": "The Chandrabhaga River, also known as the Bhima River, flows in a crescent shape around Pandharpur and is considered sacred by devotees. Pilgrims take a holy dip in the river before visiting the temple. The ghats come alive during major festivals and offer a spiritual atmosphere along the riverbanks."
  },
  {
    "title": "Vishnupad Temple",
    "location": "Pandharpur, Maharashtra",
    "description": "Vishnupad Temple marks the footprint of Lord Vishnu and is located on the banks of the Chandrabhaga River. It is believed that Lord Vishnu set foot here, and the spot holds religious significance for pilgrims, especially those seeking blessings from all Vishnu incarnations."
  },
  {
    "title": "ISKCON Pandharpur",
    "location": "Pandharpur, Maharashtra",
    "description": "ISKCON Pandharpur is a serene spiritual center offering daily bhajans, kirtans, and discourses in a well-maintained complex. The temple is dedicated to Lord Krishna and Radha and attracts followers seeking a peaceful devotional environment with modern amenities and prasadam."
  },
  {
    "title": "Kaikadi Maharaj Math",
    "location": "Pandharpur, Maharashtra",
    "description": "Kaikadi Maharaj Math is a unique ashram that educates visitors about Hindu mythology and teachings through statues and storytelling. The math features life-sized sculptures depicting stories from the Ramayana and Mahabharata, making it both spiritual and educational for all age groups."
  },
  {
    "title": "Namdev Payari",
    "location": "Vitthal Temple, Pandharpur, Maharashtra",
    "description": "Namdev Payari is the 17th step at the Vitthal Temple, named after the saint Namdev who meditated here. According to legends, Lord Vitthal appeared at this step to bless him. It is one of the holiest parts of the temple and holds deep significance for Warkari devotees."
  },
  {
    "title": "Sant Dnyaneshwar Mandir",
    "location": "Pandharpur, Maharashtra",
    "description": "Sant Dnyaneshwar Mandir pays tribute to the revered saint and poet of Maharashtra. Located near the Chandrabhaga river, the temple celebrates his literary and spiritual contributions. It’s a place of quiet reflection for devotees who follow the Warkari tradition."
  },
  {
    "title": "Sant Tukaram Mandir",
    "location": "Pandharpur, Maharashtra",
    "description": "Sant Tukaram Mandir is dedicated to the 17th-century saint-poet Tukaram, whose abhangs (devotional verses) are integral to Maharashtra’s spiritual culture. The temple honors his legacy and teachings and serves as a stop for devotees following the Wari pilgrimage route."
  },
  {
    "title": "Gopalpur Hill",
    "location": "Near Pandharpur, Maharashtra",
    "description": "Gopalpur Hill is a peaceful site located a few kilometers from Pandharpur. It is believed that Lord Krishna once spent time here with his cows. The hill is known for its panoramic views, ancient shrines, and calm environment, making it ideal for a short nature-spiritual retreat."
  }
],



"services": [
  {
    "name": "Mumbai to Pandharpur Cab",
    "description": "Plan your spiritual journey with ease by booking a cab from Mumbai to Pandharpur with Deva Cabs. Whether you're visiting the famous Vitthal Rukmini Mandir or attending Ashadi Ekadashi festivities, our cabs provide a smooth and peaceful ride. Travel in fully serviced vehicles with verified chauffeurs and enjoy door-to-door pickup, flexible timing, and affordable rates for both one-way and round-trip options."
  },
  {
    "name": "Mumbai to Tuljapur Cab",
    "description": "Visit the revered Tulja Bhavani Temple in Tuljapur comfortably with our Mumbai to Tuljapur cab service. We offer safe, AC-equipped cars ideal for long-distance travel with family or elders. Choose from hatchbacks, sedans, or spacious SUVs for your journey. Our drivers are familiar with the route and ensure a respectful, timely arrival at the temple."
  },
  {
    "name": "Mumbai to Akkalkot Taxi",
    "description": "Hire a dedicated taxi from Mumbai to Akkalkot for a serene visit to Shri Swami Samarth Maharaj Temple. Deva Cabs provides chauffeur-driven, well-maintained vehicles perfect for this spiritual journey. Our outstation cab services include one-way or round-trip options, customized itineraries, and reliable road support for added convenience during your pilgrimage."
  },
  {
    "name": "Pilgrimage cab Mumbai to Pandharpur",
    "description": "Make your religious travel comfortable and hassle-free with our pilgrimage cab service to Pandharpur. Deva Cabs specializes in sacred route travel with punctual drivers, AC vehicles, and spiritual-friendly itineraries. Whether it’s a solo visit or group trip, we cater to all needs with care, convenience, and cost-effectiveness."
  },
  {
    "name": "Book Mumbai to Tuljapur taxi",
    "description": "Easily book your taxi from Mumbai to Tuljapur with Deva Cabs. We offer instant online booking, transparent fares, and vehicle options tailored for religious travelers. Our cabs come with experienced drivers who understand the significance of the journey and offer respectful and safe service throughout."
  },
  {
    "name": "Affordable Mumbai to Akkalkot cab",
    "description": "Looking for budget-friendly cab options to Akkalkot from Mumbai? Deva Cabs provides well-maintained vehicles with professional chauffeurs at competitive rates. Our affordable packages are ideal for families or solo devotees seeking peace and comfort without overpaying."
  },
  {
    "name": "SUV taxi Mumbai to Pandharpur",
    "description": "Travel with added comfort and space in an SUV from Mumbai to Pandharpur. Perfect for groups or families, our SUVs are fitted with AC, push-back seats, and ample luggage space. They’re ideal for long pilgrimage routes and ensure everyone enjoys a restful journey."
  },
  {
    "name": "Chauffeur cab to Tuljapur from Mumbai",
    "description": "Hire a chauffeur-driven cab to Tuljapur from Mumbai for a worry-free pilgrimage experience. Our courteous drivers assist with temple schedules, rest stops, and travel coordination so you can focus on your devotion. All drivers are background-checked and experienced in long-distance spiritual routes."
  },
  {
    "name": "Mumbai to Akkalkot outstation cab",
    "description": "Our outstation cab service from Mumbai to Akkalkot is tailored for overnight or extended stays. We offer round-the-clock availability, custom stops, and optional return bookings. Perfect for pilgrim groups and temple visits, our cabs are GPS-enabled and driven by knowledgeable chauffeurs."
  },
  {
    "name": "Round trip cab Mumbai to Pandharpur",
    "description": "Planning a same-day or overnight trip? Deva Cabs offers round-trip cab services from Mumbai to Pandharpur with fixed pricing, standby driver, and no return worries. It’s a great option for senior citizens, groups, or weekend devotees heading to Pandharpur."
  },
  {
    "name": "AC cab to Tuljapur from Mumbai",
    "description": "Beat the heat during your spiritual visit with our AC cabs from Mumbai to Tuljapur. Our vehicles are serviced, comfortable, and designed for long-distance comfort. From pickup to drop, enjoy a cool and peaceful ride for your religious travel."
  },
  {
    "name": "Mumbai to Pandharpur family cab",
    "description": "Our family-friendly cab service from Mumbai to Pandharpur ensures a safe and spacious travel experience. Equipped with seat belts, clean interiors, and experienced drivers, it’s an ideal choice for pilgrims traveling with kids or elderly members."
  },
  {
    "name": "Luxury car Mumbai to Akkalkot",
    "description": "Travel to Akkalkot in luxury with our premium cab offerings. Select high-end sedans and SUVs for a superior travel experience, featuring leather interiors, chilled AC, and premium chauffeur service. Ideal for VIPs, spiritual leaders, or those seeking refined comfort."
  },
  {
    "name": "Online cab booking Pandharpur Tuljapur Akkalkot",
    "description": "Book your cab online for Pandharpur, Tuljapur, or Akkalkot in minutes. Deva Cabs’ platform offers instant confirmation, vehicle selection, and transparent billing. Whether for a single temple visit or a multi-destination pilgrimage circuit, plan your religious journey in just a few clicks."
  },
  {
    "name": "Premium pilgrimage cab Mumbai",
    "description": "Upgrade your spiritual travel with Deva Cabs’ premium pilgrimage cab service from Mumbai. Ideal for multi-temple tours or dignitary visits, we offer high-comfort vehicles, tailored itineraries, and professional drivers who understand the significance and timing of religious journeys."
  }
],
"tableData": [
  ["Mumbai to Pandharpur Cab", "-Mumbai to Tuljapur Cab"],
  ["Mumbai to Akkalkot Taxi", "-Pilgrimage cab Mumbai to Pandharpur"],
  ["Book Mumbai to Tuljapur taxi", "-Affordable Mumbai to Akkalkot cab"],
  ["SUV taxi Mumbai to Pandharpur", "-Chauffeur cab to Tuljapur from Mumbai"],
  ["Mumbai to Akkalkot outstation cab", "-Round trip cab Mumbai to Pandharpur"],
  ["AC cab to Tuljapur from Mumbai", "-Mumbai to Pandharpur family cab"],
  ["Luxury car Mumbai to Akkalkot", "-Online cab booking Pandharpur Tuljapur Akkalkot"],
  ["Premium pilgrimage cab Mumbai", ""]
],

whychoose: [
  {
    "WhyChooseheading": "Reliable Mumbai to Pandharpur Cab Service",
    "WhyChoosedescription": "Experience a seamless journey from Mumbai to the sacred town of Pandharpur with our dependable cab service. Whether you’re traveling for pilgrimage, family visits, or leisure, we ensure timely pickups, efficient route planning, and a stress-free travel experience. Our service is committed to providing punctual and comfortable transportation tailored to your needs."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles for Long-Distance Travel",
    "WhyChoosedescription": "Travel in comfort with our well-maintained, air-conditioned vehicles equipped to handle the approximately 330 km journey to Pandharpur. Enjoy ample legroom, plush seating, and sufficient luggage space to ensure a relaxing ride. Our vehicles are ideal for solo travelers, families, and groups, making your long-distance trip enjoyable and fatigue-free."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Mumbai-Pandharpur Route",
    "WhyChoosedescription": "Our professional drivers are skilled in navigating highways and rural roads en route to Pandharpur. They prioritize safety and customer comfort, making stops as needed for refreshments or breaks. Their knowledge of traffic conditions and alternate routes ensures you arrive safely and on time, every time."
  },
  {
    "WhyChooseheading": "Transparent and Competitive Pricing",
    "WhyChoosedescription": "With our Mumbai to Pandharpur cab service, you receive clear and upfront pricing without any hidden charges. Our rates include fuel, tolls, and driver allowances, allowing you to plan your budget with confidence. Enjoy premium service at affordable prices, perfect for both personal and group travel."
  },
  {
    "WhyChooseheading": "24/7 Availability to Match Your Schedule",
    "WhyChoosedescription": "Our cab service operates around the clock, giving you the flexibility to travel whenever suits you best. Early morning departures, late-night arrivals, or last-minute bookings are all accommodated with ease, ensuring you never miss an important event or pilgrimage."
  },
  {
    "WhyChooseheading": "Easy Booking with Instant Confirmation",
    "WhyChoosedescription": "Booking your Mumbai to Pandharpur cab is quick and convenient. Use our website or customer support to secure your ride instantly, complete with detailed fare breakdowns and driver information. Enjoy peace of mind from booking to journey’s end."
  },
  {
    "WhyChooseheading": "Safety-First Travel Experience",
    "WhyChoosedescription": "Your safety is our highest priority. All vehicles undergo regular maintenance and sanitation. They are equipped with essential safety features including seat belts and GPS tracking. Our drivers strictly follow safety guidelines to provide you a secure and comfortable journey to Pandharpur."
  },
  {
    "WhyChooseheading": "Customizable Travel Packages for Your Convenience",
    "WhyChoosedescription": "Whether you need a one-way trip, round trip, or stops along the way, our flexible packages can be tailored to your itinerary. We cater to families, groups, and solo travelers, providing personalized service that fits your schedule and travel preferences."
  }
]








    }









const faqData = [
  {
    question: "Can I book a cab from Mumbai to Pandharpur with Deva Cabs?",
    answer: "Yes, Deva Cabs offers comfortable and reliable cab services from Mumbai to Pandharpur for pilgrimages and personal travel."
  },
  {
    question: "How long does it take to travel from Mumbai to Pandharpur by cab?",
    answer: "The journey typically takes around 8 to 10 hours depending on road and traffic conditions."
  },
  {
    question: "What types of vehicles are available for the Mumbai to Pandharpur route?",
    answer: "We offer a wide range of vehicles including sedans, SUVs, Ertiga, Innova Crysta, and tempo travellers suitable for solo travelers and groups."
  },
  {
    question: "Can I book a cab for a one-way trip from Mumbai to Pandharpur?",
    answer: "Yes, Deva Cabs provides one-way cab services without any obligation to pay for the return journey."
  },
  {
    question: "Is advance booking available for Mumbai to Pandharpur cabs?",
    answer: "Yes, you can pre-book your cab via our website, mobile app, or by calling our customer support."
  },
  {
    question: "Are tolls and driver allowances included in the fare?",
    answer: "Tolls and driver charges are usually extra and will be transparently communicated at the time of booking."
  },
  {
    question: "Is it safe to travel from Mumbai to Pandharpur by cab?",
    answer: "Absolutely. Our drivers are background-verified and trained to provide a safe and comfortable travel experience."
  },
  {
    question: "Can I book a round trip from Mumbai to Pandharpur?",
    answer: "Yes, we offer flexible round-trip options whether you're returning the same day or after a longer stay."
  },
  {
    question: "Is the service available during night hours or early morning?",
    answer: "Yes, Deva Cabs operates 24/7, allowing you to travel at any convenient time."
  },
  {
    question: "Why choose Deva Cabs for Mumbai to Pandharpur travel?",
    answer: "Deva Cabs ensures clean vehicles, experienced drivers, timely pickups, and transparent pricing for a stress-free journey."
  }
];

const testimonialData = [
  {
    id: 43,
    name: 'Mr. Ganesh Kulkarni',
    role: 'Pilgrim',
    review: 'We booked Deva Cabs for a pilgrimage to Pandharpur. The vehicle was in great condition and the driver was polite and helpful throughout the journey.',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  },
  {
    id: 44,
    name: 'Ms. Shweta Pawar',
    role: 'Religious Traveler',
    review: 'Deva Cabs made our Mumbai to Pandharpur trip smooth and worry-free. Highly recommended for long-distance travel!',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  }
];








































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8108807171",
            "+91 9764227171",



        ],
        email: "booking@devacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Cab Service in Mumbai",
            link: "/Cab-Service-in-Mumbai"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Cab Service in Navi Mumbai",
            link: "/Cab-Service-in-Navi-Mumbai"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Cab Service in Thane",
            link: "/Cab-Service-in-Thane"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Cab Service Near Me Mumbai",
            link: "/Cab-Service-Near-Me-Mumbai"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Car Rental in Mumbai",
            link: "/Car-Rental-in-Mumbai"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Corporate Cab Services in Mumbai",
            link: "/Corporate-Cab-Services-in-Mumbai"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Online Taxi Booking Mumbai",
            link: "/Online-Taxi-Booking-Mumbai"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Wedding Car Rental Mumbai",
            link: "/Wedding-Car-Rental-Mumbai"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Tempo Traveller on Rent in Mumbai",
            link: "/Tempo-Traveller-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Innova Crysta on Rent in Mumbai",
            link: "/Innova-Crysta-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Ertiga on Rent in Mumbai",
            link: "/Ertiga-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Mini Bus on Rent in Mumbai",
            link: "/Mini-Bus-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Mumbai Airport Cab Booking",
            link: "/Mumbai-Airport-Cab-Booking"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Navi Mumbai Car Rental Service",
            link: "/Navi-Mumbai-Car-Rental-Service"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mumbai Airport to Pune Cab",
            link: "/Mumbai-Airport-to-Pune-Cab"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai Airport to Shirdi Taxi",
            link: "/Mumbai-Airport-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Mumbai Airport Cab",
            link: "/Pune-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Airport to Mumbai Cab",
            link: "/Pune-Airport-to-Mumbai-Cab"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Surat to Mumbai Airport Taxi",
            link: "/Surat-to-Mumbai-Airport-Taxi"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Nashik to Mumbai Airport Cab",
            link: "/Nashik-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Nashik Cab",
            link: "/Mumbai-to-Nashik-Cab"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Shirdi Cab",
            link: "/Mumbai-to-Shirdi-Cab"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai to Lonavala Cab",
            link: "/Mumbai-to-Lonavala-Cab"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Mumbai to Khandala Cab",
            link: "/Mumbai-to-Khandala-Cab"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Lavasa Cab",
            link: "/Mumbai-to-Lavasa-Cab"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Matheran Cab",
            link: "/Mumbai-to-Matheran-Cab"
        }
    ];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },

    ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Pandharpur Cab",
  "image": "https://devacab.com/assets/images/mumbai-to-pandharpur-cab.jpg", // Replace with actual image URL
  "description": "Book Mumbai to Pandharpur cab with Deva Cabs. Reliable pilgrimage taxi service covering Pandharpur, Tuljapur, Akkalkot with AC, SUV, luxury, and chauffeur-driven options. Easy online booking.",
  "brand": {
    "@type": "Brand",
    "name": "Deva Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1120"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "7200",
    "availability": "https://schema.org/InStock",
    "url": "https://devacab.com/mumbai-to-pandharpur-cab" // Replace with actual page URL
  }
};




    return (
        <div>
<GoogleTagManager/>
<Helmet>
  <title>Mumbai to Pandharpur Cab | Pilgrimage Taxi Service | Deva Cabs</title>
  <meta 
    name="description" 
    content="Book Mumbai to Pandharpur cab with Deva Cabs. Pilgrimage taxi service covering Pandharpur, Tuljapur, Akkalkot with AC, SUV, luxury, and chauffeur-driven options. Easy online booking." 
  />
  <meta 
    name="keywords" 
    content="Mumbai to Pandharpur Cab, Mumbai to Tuljapur Cab, Mumbai to Akkalkot Taxi, Pilgrimage cab Mumbai to Pandharpur, Book Mumbai to Tuljapur taxi, Affordable Mumbai to Akkalkot cab, SUV taxi Mumbai to Pandharpur, Chauffeur cab to Tuljapur from Mumbai, Mumbai to Akkalkot outstation cab, Round trip cab Mumbai to Pandharpur, AC cab to Tuljapur from Mumbai, Mumbai to Pandharpur family cab, Luxury car Mumbai to Akkalkot, Online cab booking Pandharpur Tuljapur Akkalkot, Premium pilgrimage cab Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <div className="breadcumb-wrapper" >
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/30.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Deva Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1" key={e.text}>
                                        <a
                                            href={e.link} // Use the separate link for each item
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt={e.text} />
                                            </div>
                                            <div className="b2">
                                                <a href={e.link} className="px-3 colorr">{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #562018',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#562018' }}>
                                            <h4 className=" lead fw-semibold whitt text-white bg-ora">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 8108807171" className="d-block  text-white">+91 8108807171</a>
                                                <a href="tel:+91 9764227171" className="d-block  text-white">+91 9764227171</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Email</h4>
                                                <a href="mailto:booking@devacab.com" className=" text-white d-block">
                                                    booking@devacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Deva Cabs<br />
                                                        SS-2 404 Sector -17 Behind Mother India School Koparkhairne Navi Mumbai 400709
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Mumbaitopandharpurcab;